var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 10.9c-1.1.5-2.3.8-3.5 1 1.2-.8 2.2-2 2.7-3.5-1.2.8-2.5 1.3-4 1.5a6.2 6.2 0 0 0-10.4 5.7C14.7 15.3 10 12.8 7 9A6.1 6.1 0 0 0 9 17.3c-1 0-2-.3-2.8-.7 0 3 2.1 5.5 5 6a6.2 6.2 0 0 1-2.8.2c.7 2.4 3 4.2 5.7 4.3A12.3 12.3 0 0 1 5 29.6a17.4 17.4 0 0 0 27-15.5c1.1-.9 2.2-2 3-3.2Z"
  })));
};
export default SvgTwitter;